
if (!customElements.get('ly-showroom-host-form-upload')) {
  class LyShowroomHostFormUpload extends HTMLElement {

    cache = new Map()

    get values() {
      return Array.from(this.cache.values())
    }

    #uploadingCount = 0

    get uploadingCount() {
      return this.#uploadingCount
    }

    set uploadingCount(val) {
      this.#uploadingCount = val
      if (this.#uploadingCount <= 0) {
        this.#uploadingCount = 0
      }

      if (this.requiredInput) {
        this.requiredInput.value = val > 0 ? '' : this.values.length
      }
    }

    connectedCallback() {
      this.uploader = this.querySelector('label.uploader')
      this.input = this.querySelector('input[type="file"]')
      this.requiredInput = this.querySelector('input:required')

      this.input.addEventListener('change', this.fileChangeHandler)
    }

    fileChangeHandler = async (evt) => {
      evt.preventDefault()
      evt.stopPropagation()

      const files = Array.from(this.input.files || [])
      if (files.length === 0) return

      // ✅ 文件类型校验
      const validFiles = []
      const invalidFiles = []

      for (const file of files) {
        if (file.type.startsWith('image/') || file.type.startsWith('video/')) {
          validFiles.push(file)
        } else {
          invalidFiles.push(file)
        }
      }

      if (invalidFiles.length > 0) {
        console.warn('以下文件类型不被允许：', invalidFiles.map(f => f.name))
      }

      if (validFiles.length === 0) return

      for (const file of validFiles) {
        this.uploadingCount += 1
        this.handleFile(file)
      }

      this.input.value = ''
    }

    /** 处理单个文件上传 */
    handleFile = async (file) => {
      const item = document.createElement('div')
      item.classList.add('item', 'loading')
      this.uploader.before(item)

      try {
        const [{ url, id }] = await uploadFiles(file)
        this.cache.set(item, url)

        const preview = document.createElement('div')
        preview.classList.add('preview')

        const img = document.createElement('img')
        img.src = url
        preview.appendChild(img)

        if (id.includes('Video')) {
          const videoTag = document.createElement('span')
          videoTag.classList.add('video-tag')
          videoTag.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <circle cx="8" cy="8" r="7.8" fill="#333333" fill-opacity="0.4" stroke="white" stroke-width="0.4"/>
                      <path d="M12 8L6 11.4641L6 4.5359L12 8Z" fill="white"/>
                    </svg>
                    `
          preview.appendChild(videoTag)
        }

        item.appendChild(preview)

        const deleteBtn = document.createElement('span')
        deleteBtn.classList.add('delete-btn', 'hidden')
        deleteBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                  <path d="M5.74973 0.750812L0.750278 5.75027M0.75 0.75L5.74945 5.74946" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                `
        item.appendChild(deleteBtn)

        deleteBtn.addEventListener('click', () => {
          this.cache.delete(item)
          item.remove()

          if (this.values.length <= 0) {
            this.requiredInput.value = ''
          }
        })

        img.onload = () => {
          item.classList.remove('loading')
          deleteBtn.classList.remove('hidden')
        }
      } catch (err) {
        console.error('上传失败', err)
        item.remove()
      } finally {
        this.uploadingCount -= 1
        if (this.values.length <= 0) {
          this.requiredInput.value = ''
        }
      }
    }

    disconnectedCallback() {
      this.input.removeEventListener('change', this.fileChangeHandler)
    }
  }

  customElements.define('ly-showroom-host-form-upload', LyShowroomHostFormUpload)
}

if (!customElements.get('ly-showroom-host-form-select')) {
  class LyShowroomHostFormSelect extends HTMLElement {

    constructor() {
      super()
    }

    connectedCallback() {
      this.selectedSpan = this.querySelector('.selected span.value')
      this.selectedInput = this.querySelector('.selected input[type="text"]')
      this.checkboxInput = this.querySelector('.selected input[type="checkbox"]')
      this.options = [...this.querySelectorAll('.option')]

      this.options.forEach(option => {
        option.addEventListener('click', this.clickHandler)
      })

      document.addEventListener('click', this.blurHandler)
    }

    clickHandler = evt => {
      this.options.forEach(p => p.classList.toggle('active', p === evt.currentTarget))
      this.selectedSpan.textContent = evt.currentTarget.dataset.value
      this.selectedInput.value = evt.currentTarget.dataset.value
    }

    blurHandler = evt => {
      if (!this.contains(evt.target)) {
        this.checkboxInput.checked = false
      }
    }

    disconnectedCallback() {
      this.options.forEach(option => {
        option.removeEventListener('click', this.clickHandler)
      })
      document.removeEventListener('click', this.blurHandler)
    }
  }

  customElements.define('ly-showroom-host-form-select', LyShowroomHostFormSelect)
}

if (!customElements.get('ly-showroom-host-form')) {
  class LyShowroomHostForm extends HTMLElement {

    connectedCallback() {
      this.form = this.querySelector('form')
      this.uploader = this.querySelector('ly-showroom-host-form-upload')
      this.spinner = this.querySelector('.loading__spinner')

      this.form.addEventListener('submit', this.submitHandler)
    }

    submitHandler = async evt => {
      evt.preventDefault()
      evt.stopPropagation()

      const fd = new FormData(this.form)

      const values = [[]]
      for (const [key, value] of fd.entries()) {
        values[0].push(value)
      }

      values[0].push(this.uploader.values.join('\n'))

      try {
        this.spinner.classList.toggle('hidden')
        const url = 'https://lulu.aries-kmc.top:3000/shopify-apihub/flexpatio/showroom/host-showroom-form'
        // const url = 'http://127.0.0.1:3000/shopify-apihub/flexpatio/showroom/host-showroom-form'
        await fetch(url,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ values })
          }
        )
        this.classList.add('is-success')
      } catch (error) {
        console.error(error)
      } finally {
        this.spinner.classList.toggle('hidden')
      }
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler)
    }
  }

  customElements.define('ly-showroom-host-form', LyShowroomHostForm)
}